import React, { FC } from 'react';
import AccountIcon from '../../icons/account.svg?react';
import { Username } from '../../interface/userDetails';

export const UserNameDetails: FC<{ username: Username }> = ({ username }) => {
  const { name, discriminator } = username;

  return (
    <div
      className="objektiv-mk3-lg flex items-center gap-2 rounded-[8px] bg-[#0E122C] px-3 py-1 text-[#ECEAED]"
    >
      <div className="text-[#FDF3E8]">
        <AccountIcon
          width={12}
          height={14}
        />
      </div>
      <span className="text-nowrap">
        {name}
        {' '}
        #
        {discriminator}
      </span>
    </div>
  );
};
